import { z } from "zod/v4";
import { trainingSlotSchema } from "../../schemas/training";
import { fetchApi, fetchVoid } from "../internal";

export const slots = {
	create: (clubId: string, groupId: string, data: unknown) =>
		fetchApi(`/clubs/${clubId}/training/groups/${groupId}/slots`, trainingSlotSchema, {
			body: JSON.stringify(data),
			method: "POST",
		}),
	delete: (clubId: string, groupId: string, slotId: string) =>
		fetchVoid(`/clubs/${clubId}/training/groups/${groupId}/slots/${slotId}`, {
			method: "DELETE",
		}),
	list: (clubId: string, groupId: string) =>
		fetchApi(`/clubs/${clubId}/training/groups/${groupId}/slots`, z.array(trainingSlotSchema)),
	update: (clubId: string, groupId: string, slotId: string, data: unknown) =>
		fetchApi(`/clubs/${clubId}/training/groups/${groupId}/slots/${slotId}`, trainingSlotSchema, {
			body: JSON.stringify(data),
			method: "PUT",
		}),
};
